module.exports = __webpack_public_path__ + "static/media/newstrans.74a066ed.png";